import { z } from 'zod';
export const setDriverStatusInput = z.object({ online: z.boolean() }).strict();
export const RATING_SOURCES = ['office', 'customer_app'];
export const rateRideInput = z
    .object({
    stars: z.number('Bitte Sterne wählen').int('Ganze Sterne').min(1, 'Mindestens 1 Stern').max(5, 'Höchstens 5 Sterne'),
    comment: z.string().trim().max(1000, 'Höchstens 1000 Zeichen').optional().transform((v) => (v ? v : undefined)),
})
    .strict();
/** Fahrzeug wählen (`vehicleId`) oder freigeben (`null`). Ist es von einem anderen online gemeldeten Fahrer belegt, kommt eine Warnung, die der Fahrer bestätigen kann. */
export const setDriverVehicleInput = z.object({ vehicleId: z.uuid('Ungültiges Fahrzeug').nullable(), confirmWarnings: z.boolean().default(false) }).strict();
//# sourceMappingURL=driver-status.js.map